import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    couponInfoStatus: false,
    uifiInfo: '',
    couponInfo: '',
    initPackageType: 2,
    bagInfo: "",  // 纯流量存储信息
    rcSelectIndex: 0, // 设备充值用户选择的套餐的下标
    firstChargeInfo: '',
    wallInfo: '',
    detainmentPopup: false,
  },
  getters: {
    couponInfoStatus: state => state.couponInfoStatus,
    uifiInfo: state => state.uifiInfo,
    couponInfo: state => state.couponInfo,
    bagInfo: state => state.bagInfo,
    firstChargeInfo: state => state.firstChargeInfo,
    initPackageType: state => state.initPackageType,
    wallInfo: state => state.wallInfo,
    rcSelectIndex: state => state.rcSelectIndex,
    detainmentPopup: state => state.detainmentPopup,
  },
  mutations: {
    setRcSelectIndex(state, date) {
      state.rcSelectIndex = date
    },
    setBagInfo(state, date) {
      state.bagInfo = date
    },
    setUifiInfo(state, date) {
      state.uifiInfo = date
    },
    setCouponInfoStatus(state, date) {
      state.couponInfoStatus = date;
    },
    setFirstChargeInfo(state, date) {
      state.firstChargeInfo = date;
    },
    setWallInfo(state, date) {
      state.wallInfo = date;
    },
    setCouponInfo(state, date) {
      state.couponInfo = date;
    },
    setInitPackageType(state, date) {
      state.initPackageType = date;
    },
    setDetainmentPopup(state, date) {
      state.detainmentPopup = date;
    },
  },
  actions: {
  },
  modules: {
  }
})
